import type { Signal } from '@preact/signals-react'
import { signal } from '@preact/signals-react'
import { isNull } from '@susu/null'
import { isUndefined } from '@susu/undefined'
import type { Configurator } from '../Configurator/Configurator'
import type { Step } from '../Step/Step'

export type ProductIdOverrideFilterEntries = Array<Step['name']['value']>

export class ProductIdOverrideFilter {
  name: Signal<string>
  entries: Signal<ProductIdOverrideFilterEntries>

  constructor(name: string, value: ProductIdOverrideFilterEntries) {
    this.name = signal(name)
    this.entries = signal(value)
  }

  isTrue(configurator: Configurator): boolean {
    const currentSelection = configurator.selection.value.current
    for (const [stepName, productIds] of Object.entries(this.entries.value)) {
      const stepProductId = configurator.selection.value.current.value[stepName]
      if (isNull(stepProductId) || isUndefined(stepProductId)) {
        continue
      }
      if (productIds.includes(stepProductId)) {
        return true
      }
    }
    return false
  }

  isFalse(configurator: Configurator) {
    return !this.isTrue(configurator)
  }

  matchedSteps(configurator: Configurator) {
    const entries: Array<Step['name']['value']> = []
    for (const [stepName, productIds] of Object.entries(this.entries.value)) {
      const stepProductId = configurator.selection.value.current.value[stepName]
      if (isNull(stepProductId) || isUndefined(stepProductId)) {
        continue
      }
      if (productIds.includes(stepProductId)) {
        entries.push(stepName)
      }
    }
    return entries
  }
}
